import { render, staticRenderFns } from "./branchs.vue?vue&type=template&id=5de4b855&"
import script from "./branchs.vue?vue&type=script&lang=ts&"
export * from "./branchs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports